import styled from 'styled-components';

import { Container } from 'Components/core';

export default styled(Container).attrs(props => ({
  

  column: true,
  seperation: '24px',
  alignItems: props.alignItems || 'center'
}))`
  background-color: #fff;
  padding: ${props => props.padding || '32px'};
  text-align: ${props => props.textAlign || 'center'};
  > p {
    margin-top:10px;
  }
`;
